import React from 'react';
import { connect } from 'react-redux';
import { DeviceType } from 'src/common/enumerations/device-type';
import { EJRecordTypes } from 'src/common/enumerations/ej-record-types';
import { AppState, store } from 'src/common/redux/configure-store';
import { SidebarActions } from 'src/common/redux/reducers/sidebar-reducer';
import Sidebar from './sidebar/sidebar';

type Props = ReturnType<typeof mapStateToProps> & ISidebarWrapperProps & typeof mapDispatchToProps;

const SidebarWrapper: React.FC<Props> = (props: Props): JSX.Element => {
  return <Sidebar {...props} />;
};

interface ISidebarWrapperProps {
  isTransactionActive: boolean;
  hasCustomer: boolean;
}

const mapStateToProps = (state: AppState): ReturnType<typeof mapStateToProps> => ({
  isCollapsed: state.sidebar.isCollapsed,
  canBeCollapsed: state.sidebar.canBeCollapsed,
  buttons: state.sidebar.buttons,
  currentPage: state.sidebar.currentPage,
  selectedItem: state.itemList.ejItems.find(item => item.Selected),
  middleAreaTabValue: state.middleArea.tabValue,
  isSidebarDisabled: state.baseView.sidebarDisabled,
  hasCashDrawer: state.deviceStatus.devices.some(
    i => i.deviceType === DeviceType.CashDrawer && i.initialized,
  ),
  hasPinpad: store.getState().pinPad.isPinpadConfigured,
  hasProducts: state.itemList.ejItems.some(
    item => item.Type === EJRecordTypes.Product && !item.Voided,
  ),
  hasCoupons: state.itemList.ejItems.some(
    item => item.Type === EJRecordTypes.Coupon && !item.Voided,
  ),
  trainingModeActive: state.posMode.trainingMode,
  saleModeFromReturnMode: state.posMode.returnMode.saleMode,
  cashierPreferences: state.cashierPreferences,
  isTenderModeActivate: state.tendering.isTendering,
});

const mapDispatchToProps = {
  toggleSidebar: SidebarActions.toggleSidebar,
  setPageNumber: SidebarActions.setCurrentPage,
};

export default connect(mapStateToProps, mapDispatchToProps)(SidebarWrapper);
